module.exports = __webpack_public_path__ + "static/media/bannerL.4ed9b579.png";